module.exports = __webpack_public_path__ + "static/media/modulepic.25ed723f.svg";